module.exports = {
  message: 'unsubscribe',
  mapper: function(opts) {
    var _events = this._eventQueue;
    this._subscriptionMap = this._subscriptionMap || {};

    var handle = opts.handle;
    var eventName = opts.action;
    var success = opts.success || function(){};
    var subId = opts.subId;

    var subscription = this._subscriptionMap[subId];
    if (subscription) {
      eventName = subscription.action;
      handle = subscription.handle;
    }

    if (_events[eventName]) {
      _events[eventName] = (_events[eventName] || []).filter(function (h) { return h != handle; });
      // 都不传，则直接取消所有
      if (!handle && !subId) {
        _events[eventName] = [];
      }
    }

    success();

    // 需要清理JS上注册的subscription吗？应该没什么必要。
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/compiled/titans/api/unsubscribe.js
// module id = 555
// module chunks = 0